import VueRouter from "vue-router";
import Vue from "vue";

Vue.use(VueRouter)

// Pages
import Login from '../pages/Login'
import LockScreen from '../pages/LockScreen'
import admin from './modules/admin'
import dashboard from './modules/dashboard'
import patientFollowUp from '../pages/patient/PatientFollowUp'
import store from '../store'
import PatientScoreView from "../components/patients/score/PatientScoreView";
import PatientPoll from "../pages/patient/PatientPoll.vue";
import ForgotPassword from "../pages/ForgotPassword.vue";
import ResetPassword from "../pages/ResetPassword.vue";

// Routes
const routes = [
    dashboard,
    admin,
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            auth: false
        }
    },
    {
        path: '/forgot-password',
        name: 'forgotPassword',
        component: ForgotPassword,
        meta: {
            auth: false
        }
    },
    {
        path: '/treatment/:treatment_id/step/:step_id/follow_up/:concern/:hash',
        name: 'follow_up.patient',
        component: patientFollowUp,
        meta: {
            auth: false
        }
    },
    {
        path: '/treatment/:treatment_id/step/:step_id/follow_up/:follow_up_id/:concern',
        name: 'follow_up.patient.score',
        component: PatientScoreView,
        props: { locked: false }
    },
    {
        path: '/polls/:poll_id/patients/:patient_id/:hash',
        name: 'polls.patient',
        component: PatientPoll,
        meta: {
            auth: false
        }
    },
    {
        path: '/locked',
        name: 'lock-screen',
        component: LockScreen,
        meta: {
            auth: true
        }
    },
    {
        path: '/auth/reset-password/:token',
        name: 'resetPassword',
        component: ResetPassword,
        meta: {
            auth: false
        }
    },
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    history: true,
    mode: 'history',
    routes,
})

router.beforeEach((to, from, next) => {
    store.dispatch('fetchLockedState');

    if(store.state.locked === "true" && to.name !== 'lock-screen' && to.name !== 'login') {
        next({ name: 'lock-screen'})
    }
    else if (store.state.locked !== "true" && to.name === 'lock-screen') {
        next({ name: 'home'})
    }
    else next()
})

export default router
